import React, { FC, memo } from "react";

import { LoadingSpinner } from "@/components/Loading";
import { ITask } from "@/data/tasks";
import { Flex } from "@/eworkitComponents/components";
import { List } from "@/views/components/List";

import { DCCListItem } from "../DesignatedCandidateCreate/DCCListItem";
import { ListPagination } from "../ListPagination";
import { WOCListItem } from "../WorkOrderConfirm/WOCListItem";

export interface ITaskListProps {
  activeTaskId?: string | number;
  tasks: ITask[];
  total?: number;
  pages?: number;
  page?: number;
  size?: number;
  working?: boolean;
  onListItemClick?: (task: ITask) => void;
  onPageChange?: (page: number) => void;
}

export const TaskList: FC<ITaskListProps> = memo(
  ({ activeTaskId, tasks, working, total, pages, page, size, onListItemClick, onPageChange }) => {
    return (
      <Flex grow={1} direction="column" style={{ height: "100%" }}>
        {working && (
          <Flex grow={1} align="center" justify="center">
            <LoadingSpinner size="lg" variant="primary" />
          </Flex>
        )}

        {!working && (
          <List grow={1}>
            {tasks.map(task =>
              task.type === "WO_CONFIRM" ? (
                <WOCListItem
                  key={task.id}
                  task={task}
                  active={task.id === activeTaskId}
                  onClick={() => onListItemClick?.(task)}
                />
              ) : (
                <DCCListItem
                  key={task.id}
                  task={task}
                  active={task.id === activeTaskId}
                  onClick={() => onListItemClick?.(task)}
                />
              ),
            )}
          </List>
        )}

        <ListPagination
          page={page}
          pages={pages}
          size={size}
          total={total}
          disabled={working}
          onPageChange={onPageChange}
        />
      </Flex>
    );
  },
);
